
import { defineComponent, onMounted, onUnmounted } from 'vue'
import ButtonIcon from '@/components/molecules/ButtonIcon.vue'
import fixBackground from '@/helpers/util/fixBackground'
import { focusInsideDialog } from '@/helpers/util/focusInsideDialog'

export default defineComponent({
  components: {
    ButtonIcon,
  },
  props: {
    heading: {
      type: String,
      default: '',
    },
    hasClose: {
      type: Boolean,
      default: true,
    },
    scrollTarget: {
      type: String,
      required: false,
    },
    warnMessage: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close'],
  setup (props, context) {
    const isServer = typeof window === 'undefined'

    const escape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        context.emit('close')
      }
    }

    if (!isServer) {
      window.addEventListener('keydown', escape)
      onUnmounted(() => {
        window.removeEventListener('keydown', escape)
      })
    }

    focusInsideDialog('.modal-window')

    onMounted(() => {
      fixBackground.fix('unsafety', props.scrollTarget)
    })
    onUnmounted(() => {
      fixBackground.cancel()
    })
  },
})
